import { isUndefined } from 'lodash';
import React, { Component } from 'react';
import './FundingSource.scss';
import BankSelect from '../BankSelect/BankSelect';
import FundingOptions from '../FundingOptions/FundingOptions';
import FundingSourceChosen from '../FundingSourceChosen/FundingSourceChosen';
import If from '../../Shared/If/If';
import { scrollElementIntoFullView } from '../../../utils/dom-utils';
import { isBuy, isRecurringBuy } from '../../../utils/transactions-util';
import { coalesce, hasValue, isJustAdded } from '../../../utils/utils';

export class FundingSource extends Component {
  constructor(props) {
    super(props);
    this.toggleEditMode = this.toggleEditMode.bind(this);
  }

  toggleEditMode(value) {
    const {
      actions: { setEditMode },
      editModeBank: { editModeFlag },
    } = this.props;
    const result =
      !isUndefined(value) && typeof value === 'boolean' ? value : !editModeFlag;
    setEditMode(result);
    scrollElementIntoFullView('funding-source-step', 15);
  }

  handleClick = (selectedBank) => {
    const {
      actions: { selectBank },
    } = this.props;
    this.toggleEditMode(true);
    selectBank(selectedBank);
  };

  render() {
    const {
      isSalesforceRep,
      customerWebViewEnabled,
      actions,
      active,
      automaticEditFund,
      agreementMap,
      completed,
      editModeBank: { editModeFlag },
      error,
      fundingSource,
      hasRasFundsOnly,
      isLoaded,
      isLoading,
      openDrawer,
      selectedBank,
      stopTransfer,
    } = this.props;
    const { accountNumber, bankAccountType, name } = coalesce(selectedBank, {});
    const noBankSelected = selectedBank === null;
    const fundingOptions = ['existing'];
    if (hasValue(fundingSource)) {
      if (!(!customerWebViewEnabled && isSalesforceRep)) {
        fundingOptions.push('addBank');
      }
    }
    return (
      <div
        className={`funding-source-container ${
          completed ? 'funding-source-space' : ''
        } e2e-funding-source-container`}
      >
        <If test={completed}>
          <div className="funding-source-collapse" onClick={openDrawer}>
            {`${name} - ${bankAccountType} `}
            <span className="blocked_data text-nowrap">{accountNumber}</span>
            <If test={isJustAdded(selectedBank)}>
              <span className="text-nowrap funding-source-just-added-label roth-conversion-review_new-fund">
                Just Added
              </span>
            </If>
            <a
              id="collapsed-edit-bank-link"
              className="college-branded-link funding-source-edit-bank-link"
            >
              Edit
            </a>
          </div>
        </If>
        <If test={isLoaded}>
          <FundingSourceChosen
            isSalesforceRep={isSalesforceRep}
            customerWebViewEnabled={customerWebViewEnabled}
            actions={actions}
            availableSources={fundingSource}
            completed={completed}
            editMode={active && editModeFlag}
            error={error}
            selectedBank={selectedBank}
            toggleEditMode={this.toggleEditMode}
            stopTransfer={stopTransfer}
          />
        </If>
        <If
          test={
            !isLoading &&
            fundingSource.length > 1 &&
            active &&
            (editModeFlag || noBankSelected)
          }
        >
          <If test={!completed}>
            <div
              className={`funding-source-div-choose ${
                noBankSelected ? 'funding-source-div-choose-line' : ''
              }`}
            >
              {noBankSelected
                ? 'Choose a bank below'
                : 'Choose a different bank:'}
            </div>
          </If>
          <div className="funding-source-bank-list">
            {fundingSource.map((bank, i) => (
              <BankSelect
                key={i}
                automaticEditFund={automaticEditFund}
                agreementMap={agreementMap}
                bankIndex={i}
                bank={bank}
                selectedBank={selectedBank}
                onBankClick={this.handleClick}
                actions={actions}
                numberOfBanks={fundingSource.length}
                className={`funding-source-bank-select e2e-funding-source-bank`}
              />
            ))}
          </div>
        </If>
        <If
          test={
            active &&
            !completed &&
            !(stopTransfer && fundingSource.length === 0) &&
            (fundingSource.length > 0 || !isRecurringBuy()) &&
            !(isBuy() && !customerWebViewEnabled && isSalesforceRep)
          }
        >
          <div className="funding-source-funding-options-container">
            <FundingOptions
              isSalesforceRep={isSalesforceRep}
              customerWebViewEnabled={customerWebViewEnabled}
              actions={actions}
              options={fundingOptions}
              stopTransfer={stopTransfer}
              hasRasFundsOnly={hasRasFundsOnly}
            />
          </div>
        </If>
      </div>
    );
  }
}

export default FundingSource;
